import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s talk about your project</h2>
                        </div>
                        <p>Tell us about your project! Our services are simple, effective, and free of unnecessary jargon. Let's dive in with a straightforward conversation. Fill out the form and click "Get In Touch" to get started.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;